module["exports"] = [
  "WVL",
  "OVL",
  "VBR",
  "ANT",
  "LIM",
  "BRU"
];




//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl_BE/address/state_abbr.js
// module id = 3319
// module chunks = 1609